(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,9918],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(16914);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AdvertisementSlot": function() { return /* reexport */ AdvertisementSlot; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
;// CONCATENATED MODULE: ./src/components/AdvertisementSlot/@editor/index.ts


var useEditorHandlers = function(name, configuration) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_advertisement_slot_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.divider
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Label"
            },
            {
                name: "theme_component_advertisement_slot_label_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.secondary.main
            },
            {
                name: "theme_component_advertisement_slot_label_color",
                label: "Text color",
                type: "color",
                default: theme.palette.secondary.contrastText
            }, 
        ],
        configuration: configuration
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./src/utils/use-local-storage.ts
var use_local_storage = __webpack_require__(18714);
;// CONCATENATED MODULE: ./src/components/AdvertisementSlot/AdvertisementSlot.tsx















var AD_SIZES = {
    "120x600": {
        width: 120,
        height: 600
    },
    "160x600": {
        width: 160,
        height: 600
    },
    "300x600": {
        width: 300,
        height: 600
    },
    "320x50": {
        width: 320,
        height: 50
    },
    "320x100": {
        width: 320,
        height: 100
    },
    "728x90": {
        width: 728,
        height: 90
    },
    "728x112": {
        width: 728,
        height: 112
    },
    "970x250": {
        width: 970,
        height: 250
    },
    "336x280": {
        width: 336,
        height: 250
    },
    "300x250": {
        width: 300,
        height: 250
    },
    "300x170": {
        width: 300,
        height: 170
    }
};
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e4qvkgu0"
})(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(0)
    };
});
var Label = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qvkgu1"
})(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        top: 0,
        left: theme.spacing(2),
        padding: theme.spacing(0.25, 1),
        color: theme.theme_component_advertisement_slot_label_color || theme.palette.secondary.contrastText,
        backgroundColor: theme.theme_component_advertisement_slot_label_background_color || theme.palette.secondary.main,
        borderRadius: "".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0 0"),
        transform: "translateY(-90%) scale(0.75)"
    };
});
var Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qvkgu2"
})("display:flex;justify-content:center;align-items:center;width:100%;height:100%;");
var AdvertisementSlot_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var SlotContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qvkgu3"
})(function(param) {
    var variant = param.variant;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, AD_SIZES[variant]), {
        overflow: "hidden"
    });
});
var AdvertisementSlot = function(props) {
    var className = props.className, variant = props.variant, slotIdentifier = props.slotIdentifier, alignment = props.alignment, configuration = props.configuration, _adType = props.adType, adType = _adType === void 0 ? "default" : _adType, other = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "variant",
        "slotIdentifier",
        "alignment",
        "configuration",
        "adType"
    ]);
    var captionRef = react.useRef(null);
    var themeOverride = (0,useTheme/* default */.Z)();
    var t = (0,esm/* useTranslation */.$G)("advertisement_slot").t;
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    var subMode = componentOptions.component_project_subscription_mode;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* default */.Z)("user-token", ""), 1), userToken = ref[0];
    var hideAdvertisement = subMode && userToken;
    var renderAdContent = function() {
        return adType === "pgs" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Inner, {
            dangerouslySetInnerHTML: {
                __html: "<pgs-ad data-pg-ad-spot='".concat(slotIdentifier, '\' style="width: 100%; height: 100%"></pgs-ad>')
            },
            style: {
                justifyContent: alignment,
                width: "100%",
                height: "100%"
            }
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Inner, {
            id: slotIdentifier,
            style: {
                justifyContent: alignment
            }
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, useEditorHandlers("Advertisement Slot", configuration), other), {
        children: hideAdvertisement ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlot_Typography, {
                        ref: captionRef,
                        variant: "caption",
                        component: "div",
                        children: t("label", "Advertisement")
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SlotContainer, {
                    variant: variant,
                    slotIdentifier: slotIdentifier,
                    theme: themeOverride,
                    children: renderAdContent()
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/AdvertisementSlot/index.ts



/***/ }),

/***/ 16914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ IndexPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./src/components/Title/index.ts + 2 modules
var Title = __webpack_require__(61546);
// EXTERNAL MODULE: ./src/components/Card/index.ts + 22 modules
var Card = __webpack_require__(74821);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(95753);
// EXTERNAL MODULE: ./src/utils/use-local-storage.ts
var use_local_storage = __webpack_require__(18714);
// EXTERNAL MODULE: ./src/contexts/CursorContext/index.tsx
var CursorContext = __webpack_require__(15888);
// EXTERNAL MODULE: ./src/types/static.tsx
var types_static = __webpack_require__(17637);
// EXTERNAL MODULE: ./src/utils/useFlattenArray.ts
var useFlattenArray = __webpack_require__(86731);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardActionArea/CardActionArea.js + 1 modules
var CardActionArea = __webpack_require__(9974);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./src/containers/CollectionsB/styled.tsx









var styled_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kr59a10"
})(function(param) {
    var theme = param.theme, isfullscreen = param.isfullscreen;
    var _obj;
    return _obj = {
        display: "grid",
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        gap: theme.spacing(2),
        gridTemplateColumns: "100%",
        gridTemplateRows: "auto",
        gridTemplateAreas: "\n        'A'\n        'D'\n        'B'\n        'C'\n        'F'\n        'E'\n        'G'"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        gridTemplateColumns: "repeat(2, 1fr)",
        gridTemplateAreas: "\n        'A A'\n        'D D'\n        'B B'\n        'C E'\n        'F F'\n        'G G'"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        gap: theme.spacing(4),
        // gridTemplate: `repeat(12, 1fr)`,
        // gridTemplateColumns: 'repeat(auto-fill, 1fr auto)',
        // gridTemplateRows: `${300 + theme.spacing(1)}px ${300 + theme.spacing(1)}px ${300 + theme.spacing(1)}px 250px 250px`,
        gridTemplateColumns: "repeat(12, 1fr)",
        gridTemplateAreas: "\n      ".concat(isfullscreen ? "\n        'A A A A A A A A A A A A'\n        'B B B B B B B B B B B B'\n        'C C C C C C E E E E E E'\n        'F F F F F F F F F F F F'\n        'G G G G G G G G G G G G'" : "'A A A A A A A A A A A A'\n        'B B B B B B B B B B B B'\n        'C C C C D D D D E E E E'\n        'F F F F F F F F F F F F'\n        'G G G G G G G G G G G G'", "\n    ")
    }), _obj;
});
var HeaderSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kr59a11"
})(function(param) {
    var theme = param.theme, isfullscreen = param.isfullscreen;
    var _obj;
    return _obj = {
        display: "grid",
        gap: theme.spacing(2),
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto",
        gridTemplateAreas: "\n        'carousel'\n        'skyscraper'\n        'editor'\n        'releases'",
        width: "100%",
        padding: theme.spacing(0, 2)
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        gridTemplateColumns: "auto auto ".concat(isfullscreen ? "0" : 300 + parseInt(theme.spacing(4).replace("px ", "")), "px"),
        gridTemplateAreas: "\n        'carousel carousel skyscraper'\n        'editor editor skyscraper'\n        'releases releases releases'"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        padding: theme.spacing(0, 2),
        gridTemplateColumns: "minmax(auto, auto) minmax(auto, 575px) ".concat(isfullscreen ? "0" : 300 + parseInt(theme.spacing(4).replace("px ", "")), "px"),
        gridTemplateAreas: "\n        'carousel editor skyscraper'\n        'releases releases skyscraper'"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("xl"), {
        gridTemplateColumns: "minmax(auto, auto) minmax(auto, 575px) ".concat(isfullscreen ? "0" : 300 + parseInt(theme.spacing(4).replace("px ", "")), "px")
    }), _obj;
});
var EditorsSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kr59a12"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "grid",
        gap: theme.spacing(2),
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gridTemplateRows: "auto",
        padding: theme.spacing(2)
    }, theme.breakpoints.up("sm"), {
        gridTemplateColumns: "repeat(".concat(theme.theme_component_number_of_popular_games_to_show || 4, ", minmax(0, 1fr))")
    });
});
var FeaturedListSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kr59a13"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "grid",
        gap: theme.spacing(2),
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gridTemplateRows: "1fr",
        width: "100%",
        padding: theme.spacing(2, 0, 0)
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        gridTemplateColumns: "repeat(5, minmax(0, 1fr))"
    }), _obj;
});
var MiddleSectionLeft = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kr59a14"
})(function(param) {
    var theme = param.theme;
    return {
        display: "grid",
        gap: theme.spacing(2),
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gridTemplateRows: "auto",
        padding: theme.spacing(2)
    };
});
var MiddleSectionRight = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kr59a15"
})(function(param) {
    var theme = param.theme;
    return {
        display: "grid",
        gap: theme.spacing(2),
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gridTemplateRows: "auto",
        padding: theme.spacing(2)
    };
});
var Box = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e1kr59a16"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[0]
    };
});
var Box1 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a17"
})(function() {
    return {
        gridArea: "A",
        borderRadius: 0
    };
});
var Box2 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a18"
})(function(param) {
    var theme = param.theme;
    return {
        gridArea: "B",
        borderRadius: 0,
        marginTop: theme.spacing(-1.25),
        // backgroundColor: '#e74c3c',
        // Very important, if left out, SwiperJS will break.
        // https://github.com/nolimits4web/swiper/issues/2914#issuecomment-787610135
        overflow: "hidden"
    };
});
var Box3 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a19"
})(function(param) {
    var theme = param.theme;
    return(// backgroundColor: '#16a085',
    (0,_define_property/* default */.Z)({
        gridArea: "C",
        justifyContent: "normal",
        alignItems: "normal",
        flexDirection: "column",
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, theme.breakpoints.up("md"), {
        marginRight: 0
    }));
});
var Box4 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a110"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        gridArea: "D",
        // backgroundColor: '#2ecc71',
        // margin: theme.spacing(0, 2),
        margin: 0,
        borderRadius: 0,
        padding: theme.spacing(2, 0)
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
        padding: theme.spacing(2),
        margin: theme.spacing(0, 2),
        borderRadius: theme.shape.borderRadius
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        margin: 0
    }), _obj;
});
var Box5 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a111"
})(function(param) {
    var theme = param.theme;
    return(// backgroundColor: '#3298db',
    (0,_define_property/* default */.Z)({
        gridArea: "E",
        justifyContent: "normal",
        alignItems: "normal",
        flexDirection: "column",
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, theme.breakpoints.up("md"), {
        marginLeft: 0
    }));
});
var Box6 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a112"
})(function(param) {
    var theme = param.theme;
    return {
        gridArea: "F",
        borderRadius: 0,
        marginTop: theme.spacing(-1.25),
        marginBottom: theme.spacing(-1.25),
        // backgroundColor: '#9b59b6',
        // Very important, if left out, SwiperJS will break.
        // https://github.com/nolimits4web/swiper/issues/2914#issuecomment-787610135
        overflow: "hidden"
    };
});
var Box7 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a113"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        gridArea: "G",
        // backgroundColor: '#3298db',
        padding: theme.spacing(2),
        borderRadius: 0
    }, theme.breakpoints.down("xs"), {
        padding: theme.spacing(2, 0)
    });
});
var Box1a = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a114"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        gridArea: "carousel",
        flexDirection: "column",
        height: "100%",
        backgroundColor: theme.palette.grey["900"]
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        maxHeight: 480
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("xl"), {
        "& > div:first-of-type": {
            aspectRatio: "16/9",
            marginTop: "auto",
            marginBottom: "auto"
        },
        "& > div:last-of-type": {
            maxHeight: "20%"
        }
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("xl"), {
        flexDirection: "row",
        "& > div:last-of-type": {
            maxWidth: "20%",
            maxHeight: "100%",
            height: "100%"
        }
    }), // backgroundColor: '#2ecc71',
    // [theme.breakpoints.only('lg')]: {
    //   padding: theme.spacing(2),
    // },
    // Very important, if left out, SwiperJS will break.
    // https://github.com/nolimits4web/swiper/issues/2914#issuecomment-787610135
    (0,_define_property/* default */.Z)(_obj, "overflow", "hidden"), _obj;
});
var Box2a = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a115"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        gridArea: "editor",
        justifyContent: "normal",
        alignItems: "normal",
        flexDirection: "column"
    }, theme.breakpoints.up("lg"), {
        maxHeight: 480
    });
});
var Box3a = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a116"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        gridArea: "skyscraper",
        // backgroundColor: '#9b59b6',
        padding: theme.spacing(2),
        maxHeight: "calc(600px + ".concat(theme.spacing(4), ")")
    }, theme.breakpoints.down("xs"), {
        padding: theme.spacing(2, 0),
        margin: theme.spacing(0, -2),
        borderRadius: 0
    });
});
var Box4a = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box, {
    target: "e1kr59a117"
})(function(param) {
    var theme = param.theme;
    return {
        gridArea: "releases",
        justifyContent: "flex-end",
        alignItems: "normal",
        flexDirection: "column",
        background: "none",
        marginTop: theme.spacing(-1.25)
    };
});
var CardPaperColorElevationFlat = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e1kr59a118"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        overflow: "hidden"
    };
});
var CardActionAreaFlat = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardActionArea/* default */.Z, {
    target: "e1kr59a119"
})(function() {
    return {
        display: "flex",
        flexDirection: "column",
        height: "100%"
    };
});
var CardAssetFlat = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* CardAsset */.HW, {
    target: "e1kr59a120"
})(function(param) {
    var theme = param.theme;
    return {
        borderRadius: theme.shape.borderRadius,
        marginBottom: 0,
        overflow: "hidden"
    };
});
var CardContentFlat = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kr59a121"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0.25),
        maxWidth: "calc(100% - ".concat(theme.spacing(4), ")")
    };
});
var CardTypographyFlat = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(styled_Typography, {
    target: "e1kr59a122"
})(function() {
    return {
        width: "100%",
        height: "fit-content",
        display: "inline-block"
    };
});
var CardSkeletonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* CardSkeleton */.q4, {
    target: "e1kr59a123"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        aspectRatio: "16/9"
    };
});
var CardSkeletonGrid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* CardSkeleton */.q4, {
    target: "e1kr59a124"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        aspectRatio: "4/3"
    };
});

;// CONCATENATED MODULE: ./src/containers/CollectionsB/CollectionsB.tsx
























var AdvertisementSlot = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 29918)).then(function(mod) {
        return mod.AdvertisementSlot;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29918)
            ];
        }
    },
    ssr: false
});
var CollectionSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7839).then(__webpack_require__.bind(__webpack_require__, 67839)).then(function(mod) {
        return mod.CollectionSection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67839)
            ];
        }
    },
    ssr: false
});
var CarouselList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4386), __webpack_require__.e(4905), __webpack_require__.e(1147)]).then(__webpack_require__.bind(__webpack_require__, 24905)).then(function(mod) {
        return mod.CarouselList;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24905)
            ];
        }
    },
    ssr: false
});
var CarouselThumbs = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4386), __webpack_require__.e(4045)]).then(__webpack_require__.bind(__webpack_require__, 49723));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49723)
            ];
        }
    },
    ssr: true
});
var CollectionsB_Typography = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function(props, ref) {
    return useHighlightHandlers(MuiTypography, _object_spread({
        forwardedRef: ref
    }, props));
})));
var CollectionsB_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var AdvertisementSlotStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(_param) {
    var rest = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlot, (0,src_object_spread/* default */.Z)({}, rest));
}, {
    target: "e8goti70"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0]
    };
});
var CardStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* Card */.Zb, {
    target: "e8goti71"
})(function(param) {
    var theme = param.theme, template = param.template, hoverEffect = param.hoverEffect, cardBorder = param.cardBorder;
    return {
        width: "100%",
        backgroundColor: theme.theme_component_card_background_color || theme.palette.background.paper,
        boxShadow: theme.theme_component_card_box_shadow || theme.shadows[3],
        borderRadius: template === "big" ? 0 : "".concat(theme.theme_component_card_border_radius, "px") || 0,
        border: cardBorder || "".concat(theme.theme_component_card_content_border, "px") || 0,
        borderStyle: theme.theme_component_card_content_border ? "solid" : "none",
        borderColor: theme.theme_component_card_content_border ? theme.theme_component_card_content_border_color : "none",
        transition: "transform ".concat(theme.transitions.duration.shortest, "ms ").concat(theme.transitions.easing.easeInOut),
        "&:hover": hoverEffect && {
            transform: "scale3d(1.05, 1.05, 1)"
        }
    };
});
var AdvertisementSlotBottom = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box7, {
        elevation: 0,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
            slotIdentifier: props.id || "idhb-bottom-970",
            variant: props.variant,
            elevation: 1,
            configuration: types_static/* COLLECTIONS_B_TOP */.bP
        })
    });
};
var AdvertisementSlotMiddle = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box4, {
        className: "testbox4",
        elevation: 1,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
            slotIdentifier: props.id || "idhb-middle-336",
            variant: "336x280",
            elevation: 2,
            configuration: types_static/* COLLECTIONS_B_MIDDLE */.N1
        })
    });
};
var AdvertisementSlotTop = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box3a, {
        elevation: 1,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
            slotIdentifier: props.id || "idhb-right-300_1",
            variant: props.variant,
            elevation: 2,
            configuration: types_static/* COLLECTIONS_B_BOTTOM */.yn
        })
    });
};
var CollectionsB = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35;
    var collections = props.collections;
    var t = (0,esm/* useTranslation */.$G)("collections_b").t;
    var ref36 = (0,react_intersection_observer/* useInView */.YD)(), ref37 = ref36.ref, inView = ref36.inView;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var enabled = (0,CursorContext/* useCursorContext */.r)().enabled;
    var ref38 = appContext.useConfig(), assetUrl = ref38.assetUrl, componentOptions = ref38.componentOptions, project = ref38.project;
    var header_lift = project.features.ads.header_lift;
    var theme = (0,useTheme/* default */.Z)();
    var md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    var isBetweenMdAndLg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.between("md", "lg"));
    var mdDown = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    var lg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    var panel = (0,CursorContext/* useCursorContext */.r)().panel;
    var buttonMiddleLeftRef = react.useRef(null);
    var buttonMiddleRightRef = react.useRef(null);
    var editorCardRefs = react.useRef([]);
    var middleLeftCardRefs = react.useRef([]);
    var middleRightCardRefs = react.useRef([]);
    // @ts-ignore
    editorCardRefs.current = (0,_to_consumable_array/* default */.Z)(Array(12)).map(function(game, index) {
        var _index;
        // @ts-ignore
        return (_index = editorCardRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    // @ts-ignore
    middleLeftCardRefs.current = (0,_to_consumable_array/* default */.Z)(Array(12)).map(function(game, index) {
        var _index;
        // @ts-ignore
        return (_index = middleLeftCardRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    // @ts-ignore
    middleRightCardRefs.current = (0,_to_consumable_array/* default */.Z)(Array(12)).map(function(game, index) {
        var _index;
        // @ts-ignore
        return (_index = middleRightCardRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    react.useEffect(function() {
        if (header_lift) {
            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18505)).then(function(param) {
                var adsRequest = param.adsRequest;
                var obj = {
                    "idhb-right-300_1": !componentOptions.component_right_ads_disable || !componentOptions.component_right_ads_tablet_disable || !componentOptions.component_right_ads_mobile_disable,
                    "idhb-middle-336": !componentOptions.component_middle_center_ads_disable || !componentOptions.component_middle_center_ads_tablet_disable || !componentOptions.component_middle_center_ads_mobile_disable,
                    "idhb-bottom-970": !componentOptions.component_bottom_ads_disable || !componentOptions.component_bottom_ads_tablet_disable || !componentOptions.component_bottom_ads_mobile_disable
                };
                var adsList = Object.keys(obj).filter(function(key) {
                    return obj[key];
                });
                adsRequest(adsList);
            });
        }
    }, [
        header_lift,
        componentOptions
    ]);
    var cardType = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_carousel_card_type;
    var ref39 = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* default */.Z)("lastplayed:current", []), 1), lastPlayedGames = ref39[0];
    var showLastPlayedCarousel = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_homepage_show_last_played_carousel;
    var recommendedCollection = collections.find(function(c) {
        return c.code.includes("recommended");
    }) || {
        games: []
    };
    var homeCollections = collections === null || collections === void 0 ? void 0 : collections.filter(function(c) {
        return !c.code.includes("recommended");
    });
    var flattenedData = (0,useFlattenArray/* default */.Z)(lastPlayedGames || []);
    var headerSectionNotAds = function() {
        if (panel) return false;
        return !componentOptions.component_ads_disabled ? lg ? componentOptions.component_right_ads_disable : isBetweenMdAndLg ? componentOptions.component_right_ads_tablet_disable : componentOptions.component_right_ads_mobile_disable : componentOptions.component_ads_disabled;
    };
    var rootSectionNotAds = function() {
        if (panel) return false;
        return !componentOptions.component_ads_disabled ? lg ? componentOptions.component_middle_center_ads_disable : isBetweenMdAndLg ? componentOptions.component_middle_center_ads_tablet_disable : componentOptions.component_middle_center_ads_mobile_disable : componentOptions.component_ads_disabled;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, {
        ref: ref37,
        isfullscreen: rootSectionNotAds(),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box1, {
                elevation: 0,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderSection, {
                    className: "header-section",
                    isfullscreen: headerSectionNotAds(),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box1a, {
                            elevation: 1,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselThumbs, {
                                items: showLastPlayedCarousel && flattenedData && flattenedData.length > 0 ? (0,_to_consumable_array/* default */.Z)(flattenedData).concat((0,_to_consumable_array/* default */.Z)(recommendedCollection.games.map(function(game) {
                                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, game), {
                                        trend: true
                                    });
                                }))) : (0,_to_consumable_array/* default */.Z)(Array(4)).map(function(slot, index) {
                                    var ref, ref1;
                                    return (ref = homeCollections[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.games) === null || ref1 === void 0 ? void 0 : ref1[index];
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box2a, {
                            elevation: 1,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    className: "birasitest",
                                    component: "h1",
                                    variant: "h2",
                                    align: "left",
                                    style: {
                                        paddingLeft: "16px",
                                        borderBottomWidth: 1
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        href: "/".concat((ref = homeCollections[1]) === null || ref === void 0 ? void 0 : ref.type, "/").concat((ref1 = homeCollections[1]) === null || ref1 === void 0 ? void 0 : ref1.slug),
                                        title: ((ref2 = homeCollections[1]) === null || ref2 === void 0 ? void 0 : ref2.name) || undefined,
                                        underline: "hover",
                                        children: ((ref3 = homeCollections[1]) === null || ref3 === void 0 ? void 0 : ref3.name) || "Popular games"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorsSection, {
                                    children: (0,_to_consumable_array/* default */.Z)(Array(((ref4 = homeCollections[1]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.games) === null || ref5 === void 0 ? void 0 : ref5.length) > 12 ? 12 : (ref6 = homeCollections[1]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.games) === null || ref7 === void 0 ? void 0 : ref7.length)).map(function(slot, index) {
                                        var ref, ref1;
                                        return (ref = homeCollections[1]) === null || ref === void 0 ? void 0 : (ref1 = ref.games) === null || ref1 === void 0 ? void 0 : ref1[index];
                                    }).map(function(item, index) {
                                        return item ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardPaperColorElevationFlat, {
                                            elevation: 1,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardActionAreaFlat, {
                                                component: Link/* Link */.r,
                                                href: "".concat(enabled ? "#" : "".concat(item.slug)),
                                                title: item.name || undefined,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardAssetFlat, {
                                                        src: "".concat(assetUrl).concat(item.images.cover16x9 || item.images.cover, "/"),
                                                        alt: item.name || "Cover",
                                                        width: componentOptions.component_card_width || 512,
                                                        height: componentOptions.component_card_height || 288,
                                                        layout: "responsive",
                                                        sizes: "(min-width:1200px) 8.333vw, (min-width:900px) 16.333vw, (min-width:600px) 25vw, 50vw"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentFlat, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTypographyFlat, {
                                                            // @ts-ignore
                                                            ref: editorCardRefs.current[index],
                                                            variant: "caption",
                                                            component: "span",
                                                            noWrap: true,
                                                            children: item.name
                                                        })
                                                    })
                                                ]
                                            })
                                        }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonGrid, {
                                            elevation: 2
                                        }, index);
                                    })
                                })
                            ]
                        }),
                        panel ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotTop, {
                            variant: md ? "300x600" : "320x50"
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: !componentOptions.component_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    lg && !componentOptions.component_right_ads_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotTop, {
                                        id: componentOptions.component_right_ads_id,
                                        variant: md ? "300x600" : "320x50"
                                    }),
                                    isBetweenMdAndLg && !componentOptions.component_right_ads_tablet_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotTop, {
                                        id: componentOptions.component_right_ads_id,
                                        variant: md ? "300x600" : "320x50"
                                    }),
                                    mdDown && !componentOptions.component_right_ads_mobile_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotTop, {
                                        id: componentOptions.component_right_ads_id,
                                        variant: md ? "300x600" : "320x50"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box4a, {
                            elevation: 0,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h2",
                                    variant: "h2",
                                    align: "left",
                                    disableGutters: true,
                                    style: {
                                        paddingLeft: "16px",
                                        borderBottomWidth: 1
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        href: "/".concat((ref8 = homeCollections[2]) === null || ref8 === void 0 ? void 0 : ref8.type, "/").concat((ref9 = homeCollections[2]) === null || ref9 === void 0 ? void 0 : ref9.slug),
                                        title: ((ref10 = homeCollections[2]) === null || ref10 === void 0 ? void 0 : ref10.name) || undefined,
                                        underline: "hover",
                                        children: ((ref11 = homeCollections[2]) === null || ref11 === void 0 ? void 0 : ref11.name) || "New releases"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedListSection, {
                                    children: (0,_to_consumable_array/* default */.Z)(Array(mdDown ? 6 : 5)).map(function(slot, index) {
                                        var ref, ref1;
                                        return (ref = homeCollections[2]) === null || ref === void 0 ? void 0 : (ref1 = ref.games) === null || ref1 === void 0 ? void 0 : ref1[index];
                                    }).map(function(item, index) {
                                        return (item === null || item === void 0 ? void 0 : item.id) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardStyled, {
                                            href: "".concat(item.slug),
                                            src: "".concat(assetUrl).concat(item.images.cover16x9 || item.images.cover, "/"),
                                            alt: item.name || "Cover",
                                            template: cardType || types_enum/* CardTypeEnum.DEFAULT */.mq.DEFAULT,
                                            title: item.name || undefined,
                                            width: componentOptions.component_card_width || 512,
                                            height: componentOptions.component_card_height || 288,
                                            layout: "responsive",
                                            sizes: "(min-width:900px) 14vw, (min-width:600px) 33.333vw, 50vw",
                                            typographyOptions: {
                                                align: "left"
                                            }
                                        }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonStyled, {
                                            elevation: 2
                                        }, index);
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box2, {
                elevation: 0,
                children: inView && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                            component: "h2",
                            variant: "h2",
                            align: "left",
                            style: {
                                paddingLeft: "16px",
                                borderBottomWidth: 1
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                href: "/".concat((ref12 = homeCollections[3]) === null || ref12 === void 0 ? void 0 : ref12.type, "/").concat((ref13 = homeCollections[3]) === null || ref13 === void 0 ? void 0 : ref13.slug),
                                title: ((ref14 = homeCollections[3]) === null || ref14 === void 0 ? void 0 : ref14.name) || undefined,
                                underline: "hover",
                                children: ((ref15 = homeCollections[3]) === null || ref15 === void 0 ? void 0 : ref15.name) || "Puzzle"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                            padding: theme.spacing(2),
                            items: (0,_to_consumable_array/* default */.Z)(Array(12)).map(function(slot, index) {
                                var ref, ref1;
                                return (ref = homeCollections[3]) === null || ref === void 0 ? void 0 : (ref1 = ref.games) === null || ref1 === void 0 ? void 0 : ref1[index];
                            }),
                            cardOptions: {
                                width: componentOptions.component_card_width || 512,
                                height: componentOptions.component_card_height || 288,
                                sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                layout: "responsive",
                                template: cardType || types_enum/* CardTypeEnum.EXTENSIVE */.mq.EXTENSIVE,
                                typographyOptions: {
                                    align: "left"
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box3, {
                elevation: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                        component: "h2",
                        variant: "h2",
                        align: "left",
                        style: {
                            paddingLeft: "16px",
                            borderBottomWidth: 1
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                            href: "/".concat((ref16 = homeCollections[4]) === null || ref16 === void 0 ? void 0 : ref16.type, "/").concat((ref17 = homeCollections[4]) === null || ref17 === void 0 ? void 0 : ref17.slug),
                            title: ((ref18 = homeCollections[4]) === null || ref18 === void 0 ? void 0 : ref18.name) || undefined,
                            underline: "hover",
                            children: ((ref19 = collections[4]) === null || ref19 === void 0 ? void 0 : ref19.name) || "Simulation"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiddleSectionLeft, {
                        children: (0,_to_consumable_array/* default */.Z)(Array(6)).map(function(slot, index) {
                            var ref, ref1;
                            return (ref = homeCollections[4]) === null || ref === void 0 ? void 0 : (ref1 = ref.games) === null || ref1 === void 0 ? void 0 : ref1[index];
                        }).map(function(item, index) {
                            return item ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardPaperColorElevationFlat, {
                                elevation: 2,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardActionAreaFlat, {
                                    component: Link/* Link */.r,
                                    href: "".concat(item.slug),
                                    title: item.name || undefined,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardAssetFlat, {
                                            src: "".concat(assetUrl).concat(item.images.cover16x9 || item.images.cover, "/"),
                                            alt: item.name || "Cover",
                                            width: componentOptions.component_card_width || 512,
                                            height: componentOptions.component_card_height || 288,
                                            layout: "responsive",
                                            sizes: "(min-width:1200px) 8.333vw, (min-width:900px) 16.666vw, (min-width:600px) 33.333vw, 50vw"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentFlat, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTypographyFlat, {
                                                // @ts-ignore
                                                ref: middleRightCardRefs.current[index],
                                                variant: "caption",
                                                component: "span",
                                                noWrap: true,
                                                children: item.name
                                            })
                                        })
                                    ]
                                })
                            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonGrid, {
                                elevation: 2
                            }, index);
                        })
                    }),
                    ((ref20 = homeCollections[4]) === null || ref20 === void 0 ? void 0 : ref20.type) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsB_Button, {
                        ref: buttonMiddleLeftRef,
                        color: "primary",
                        variant: "contained",
                        disableElevation: true,
                        sx: {
                            marginTop: "auto",
                            borderRadius: "0 0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px")
                        },
                        // Can't use href to send an object; https://github.com/mui/material-ui/issues/24106
                        component: Link/* Link */.r,
                        href: "/".concat((ref21 = homeCollections[4]) === null || ref21 === void 0 ? void 0 : ref21.type, "/").concat((ref22 = homeCollections[4]) === null || ref22 === void 0 ? void 0 : ref22.slug),
                        title: ((ref23 = homeCollections[4]) === null || ref23 === void 0 ? void 0 : ref23.name) || undefined,
                        children: t("view_all_label", "View all")
                    })
                ]
            }),
            panel ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotMiddle, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: !componentOptions.component_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        lg && !componentOptions.component_middle_center_ads_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotMiddle, {
                            id: componentOptions.component_center_middle_ads_id
                        }),
                        isBetweenMdAndLg && !componentOptions.component_middle_center_ads_tablet_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotMiddle, {
                            id: componentOptions.component_center_middle_ads_id
                        }),
                        mdDown && !componentOptions.component_middle_center_ads_mobile_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotMiddle, {
                            id: componentOptions.component_center_middle_ads_id
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box5, {
                elevation: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                        component: "h2",
                        variant: "h2",
                        align: "left",
                        style: {
                            paddingLeft: "16px",
                            borderBottomWidth: 1
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                            href: "/".concat((ref24 = homeCollections[5]) === null || ref24 === void 0 ? void 0 : ref24.type, "/").concat((ref25 = homeCollections[5]) === null || ref25 === void 0 ? void 0 : ref25.slug),
                            title: ((ref26 = homeCollections[5]) === null || ref26 === void 0 ? void 0 : ref26.name) || undefined,
                            underline: "hover",
                            children: ((ref27 = homeCollections[5]) === null || ref27 === void 0 ? void 0 : ref27.name) || "Hypercasual"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiddleSectionRight, {
                        children: (0,_to_consumable_array/* default */.Z)(Array(6)).map(function(slot, index) {
                            var ref, ref1;
                            return (ref = homeCollections[5]) === null || ref === void 0 ? void 0 : (ref1 = ref.games) === null || ref1 === void 0 ? void 0 : ref1[index];
                        }).map(function(item, index) {
                            return item ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardPaperColorElevationFlat, {
                                elevation: 2,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardActionAreaFlat, {
                                    component: Link/* Link */.r,
                                    href: "".concat(item.slug),
                                    title: item.name || undefined,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardAssetFlat, {
                                            src: "".concat(assetUrl).concat(item.images.cover16x9 || item.images.cover, "/"),
                                            alt: item.name || "Cover",
                                            width: componentOptions.component_card_width || 512,
                                            height: componentOptions.component_card_height || 288,
                                            layout: "responsive",
                                            sizes: "(min-width:1200px) 8.333vw, (min-width:900px) 16.666vw, (min-width:600px) 33.333vw, 50vw"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentFlat, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTypographyFlat, {
                                                // @ts-ignore
                                                ref: middleLeftCardRefs.current[index],
                                                variant: "caption",
                                                component: "span",
                                                noWrap: true,
                                                children: item.name
                                            })
                                        })
                                    ]
                                }, index)
                            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonGrid, {
                                elevation: 2
                            }, index);
                        })
                    }),
                    ((ref28 = homeCollections[5]) === null || ref28 === void 0 ? void 0 : ref28.type) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsB_Button, {
                        ref: buttonMiddleRightRef,
                        color: "primary",
                        variant: "contained",
                        disableElevation: true,
                        sx: {
                            marginTop: "auto",
                            borderRadius: "0 0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px")
                        },
                        // Can't use href to send an object; https://github.com/mui/material-ui/issues/24106
                        component: Link/* Link */.r,
                        href: "/".concat((ref29 = homeCollections[5]) === null || ref29 === void 0 ? void 0 : ref29.type, "/").concat((ref30 = homeCollections[5]) === null || ref30 === void 0 ? void 0 : ref30.slug),
                        title: ((ref31 = homeCollections[5]) === null || ref31 === void 0 ? void 0 : ref31.name) || undefined,
                        children: t("view_all_label", "View all")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box6, {
                elevation: 0,
                children: inView && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                            component: "h2",
                            variant: "h2",
                            align: "left",
                            style: {
                                paddingLeft: "16px",
                                borderBottomWidth: 1
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                href: "/".concat((ref32 = homeCollections[6]) === null || ref32 === void 0 ? void 0 : ref32.type, "/").concat((ref33 = homeCollections[6]) === null || ref33 === void 0 ? void 0 : ref33.slug),
                                title: ((ref34 = homeCollections[6]) === null || ref34 === void 0 ? void 0 : ref34.name) || undefined,
                                underline: "hover",
                                children: ((ref35 = homeCollections[6]) === null || ref35 === void 0 ? void 0 : ref35.name) || "Multiplayer"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                            padding: theme.spacing(2),
                            items: (0,_to_consumable_array/* default */.Z)(Array(12)).map(function(slot, index) {
                                var ref, ref1;
                                return (ref = homeCollections[6]) === null || ref === void 0 ? void 0 : (ref1 = ref.games) === null || ref1 === void 0 ? void 0 : ref1[index];
                            }),
                            cardOptions: {
                                width: componentOptions.component_card_width || 512,
                                height: componentOptions.component_card_height || 288,
                                sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                layout: "responsive",
                                typographyOptions: {
                                    align: "left"
                                }
                            }
                        })
                    ]
                })
            }),
            panel ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotBottom, {
                variant: lg ? "970x250" : md ? "728x90" : "320x50"
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: !componentOptions.component_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        lg && !componentOptions.component_bottom_ads_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotBottom, {
                            id: componentOptions.component_bottom_ads_id,
                            variant: lg ? "970x250" : md ? "728x90" : "320x50"
                        }),
                        isBetweenMdAndLg && !componentOptions.component_bottom_ads_tablet_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotBottom, {
                            id: componentOptions.component_bottom_ads_id,
                            variant: lg ? "970x250" : md ? "728x90" : "320x50"
                        }),
                        mdDown && !componentOptions.component_bottom_ads_mobile_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotBottom, {
                            id: componentOptions.component_bottom_ads_id,
                            variant: lg ? "970x250" : md ? "728x90" : "320x50"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/CollectionsB/index.ts


;// CONCATENATED MODULE: ./src/generated/index/index.tsx




function View(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsB, (0,src_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./src/layouts/BaseLayout/index.tsx + 5 modules
var BaseLayout = __webpack_require__(92176);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/localize-helpers.ts
var localize_helpers = __webpack_require__(98751);
// EXTERNAL MODULE: ./src/components/AdvertisementSlot/index.ts + 2 modules
var components_AdvertisementSlot = __webpack_require__(29918);
// EXTERNAL MODULE: ./src/components/SubscriptionModal/index.tsx
var SubscriptionModal = __webpack_require__(96410);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./src/pages/index.tsx









// Koşullu import için adsRequest burada kaldırıldı











var pages_AdvertisementSlotBottom = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_AdvertisementSlot.AdvertisementSlot, {
    target: "e1lcxqjd0"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        boxShadow: theme.shadows[0],
        marginTop: theme.spacing(4),
        position: "sticky",
        bottom: "0",
        margin: "auto",
        background: "white",
        width: "728px",
        height: "90px",
        zIndex: "1"
    }, theme.breakpoints.down("lg"), {
        width: "364px",
        height: "45px"
    });
});
var Script = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("script", {
    target: "e1lcxqjd1"
})();
var __N_SSG = true;
function IndexPage(props) {
    var ref;
    var collections = props.collections, pageContext = props.pageContext;
    var ref1 = (0,esm/* useTranslation */.$G)([
        "common",
        "index"
    ]), t = ref1.t, i18n = ref1.i18n;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var _ref = appContext.useConfig(), name = _ref.name, assetAbsoluteUrl = _ref.assetAbsoluteUrl, url = _ref.url, componentOptions = _ref.componentOptions, project = _ref.project, noFollow = _ref.noFollow, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "name",
        "assetAbsoluteUrl",
        "url",
        "componentOptions",
        "project",
        "noFollow"
    ]);
    var router = (0,next_router.useRouter)();
    var paths = (0,localize_helpers/* getLocalizedPaths */.mT)(router);
    var slugs = (0,localize_helpers/* getLocalizedSlugs */.fD)(router);
    var pageContextWithPaths = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pageContext), {
        paths: paths,
        slugs: slugs,
        slug: (0,localize_helpers/* cleanSlug */.Hm)(router.pathname)
    });
    var siteUrl = "".concat(url === null || url === void 0 ? void 0 : url.replace(/\/+$/, ""));
    var stickyAdvertisement = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_advertisement_show;
    var header_lift = project.features.ads.header_lift;
    react.useEffect(function() {
        if (header_lift) {
            var loadAdsRequest = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var adsRequest;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18505))
                                ];
                            case 1:
                                adsRequest = _state.sent().adsRequest;
                                adsRequest([
                                    "idhb-bottom-90"
                                ]);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function loadAdsRequest() {
                    return _ref.apply(this, arguments);
                };
            }();
            loadAdsRequest();
        }
    }, [
        header_lift
    ]);
    react.useEffect(function() {
        if (!header_lift) return;
        var events = router.events;
        var handleRouteChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var adsRequest;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18505))
                            ];
                        case 1:
                            adsRequest = _state.sent().adsRequest;
                            adsRequest([
                                "idhb-bottom-90"
                            ]);
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleRouteChange() {
                return _ref.apply(this, arguments);
            };
        }();
        events.on("routeChangeComplete", handleRouteChange);
        events.on("hashChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
            events.off("hashChangeComplete", handleRouteChange);
        };
    }, [
        router,
        header_lift
    ]);
    var seoTitle = i18n.exists("index:title", {
        fallbackLng: pageContextWithPaths.locale
    }) ? t("index:title") : t("common:title");
    var seoDescription = i18n.exists("index:description", {
        fallbackLng: pageContextWithPaths.locale
    }) ? t("index:description") : t("common:description");
    // Customized SEO
    var seo = appContext.useSeo().seo;
    // Homepage page
    if (seo === null || seo === void 0 ? void 0 : seo.pages) {
        var ref2;
        var currentPageSEO = (ref2 = seo.pages) === null || ref2 === void 0 ? void 0 : ref2.home;
        if (currentPageSEO && router.locale) {
            var seoCurrentLanguage = currentPageSEO === null || currentPageSEO === void 0 ? void 0 : currentPageSEO[router.locale];
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.title) {
                seoTitle = seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.title;
            }
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.description) {
                seoDescription = seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.description;
            }
        }
    }
    var showSubscriptionModal = componentOptions.component_project_subscription_mode;
    var ssrSeo;
    if ((props === null || props === void 0 ? void 0 : props.seo) && props.seo[0]) {
        var ref3;
        var seoObject = props.seo[0];
        if (((ref3 = seoObject.pages) === null || ref3 === void 0 ? void 0 : ref3.home) && router.locale) {
            var seoCurrentLanguage1 = seoObject.pages.home[router.locale];
            if (seoCurrentLanguage1.json_ld) {
                ssrSeo = seoCurrentLanguage1.json_ld;
            }
        }
    }
    var languageAlternatives = (0,localize_helpers/* getLocalizedPaths */.mT)(router).map(function(path) {
        return {
            hrefLang: path.locale,
            href: (ssrSeo === null || ssrSeo === void 0 ? void 0 : ssrSeo.url) ? "".concat(ssrSeo.url).concat((0,localize_helpers/* getLocalizedPaths */.mT)(router)[0].path) : "".concat(url).concat(path.path)
        };
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            showSubscriptionModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscriptionModal/* SubscriptionModal */.u, {}),
            (componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_facebook_og_image_url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                nofollow: noFollow ? true : false,
                noindex: noFollow ? true : false,
                title: seoTitle,
                description: seoDescription,
                languageAlternates: languageAlternatives.map(function(locale) {
                    return {
                        hrefLang: locale.hrefLang,
                        href: locale.href
                    };
                }),
                openGraph: {
                    images: [
                        {
                            url: "".concat(componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_facebook_og_image_url),
                            width: 512,
                            height: 512,
                            alt: "".concat(seoTitle)
                        }, 
                    ],
                    url: componentOptions.component_facebook_og_url ? componentOptions.component_facebook_og_url : url,
                    type: "website"
                }
            }),
            collections.length > 0 && ((ref = collections[0]) === null || ref === void 0 ? void 0 : ref.games.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    !componentOptions.component_breadcrumb_json_ld_is_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                        itemListElements: pageContextWithPaths.breadcrumbs.map(function(crumb, index) {
                            return {
                                position: index + 1,
                                name: crumb.name,
                                item: crumb.href
                            };
                        })
                    }),
                    ssrSeo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Script, {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify((0,src_object_spread/* default */.Z)({
                                "@type": ssrSeo["@type"],
                                "@context": ssrSeo["@context"]
                            }, Object.keys(ssrSeo).reduce(function(acc, key) {
                                if (key !== "@context" && key !== "@type") {
                                    acc[key] = ssrSeo[key];
                                }
                                return acc;
                            }, {})))
                        }
                    }),
                    !componentOptions.component_collection_json_ld_is_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* CollectionPageJsonLd */.yr, {
                        name: t("common:title"),
                        hasPart: collections.map(function(collection) {
                            return {
                                about: collection.description,
                                author: {
                                    name: name
                                },
                                name: collection.name,
                                audience: "Internet",
                                keywords: "schema",
                                thumbnailUrl: "".concat(assetAbsoluteUrl).concat(collection.images.cover1x1 || collection.images.cover, "/?ar[r]=1x1&ar[w]=512&fmt=.png"),
                                image: "".concat(assetAbsoluteUrl).concat(collection.images.cover1x1 || collection.images.cover, "/")
                            };
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(View, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                pageContext: pageContextWithPaths
            })),
            stickyAdvertisement && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* BrowserView */.I3, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pages_AdvertisementSlotBottom, {
                            configuration: types_static/* HOME_MIDDLE_ADS_CONFIGURATION */.$m,
                            elevation: 1,
                            slotIdentifier: componentOptions.component_home_middle_id || componentOptions.component_game_ads_id || "idhb-bottom-90",
                            variant: "728x90"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* MobileView */.$, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pages_AdvertisementSlotBottom, {
                            configuration: types_static/* HOME_MIDDLE_ADS_CONFIGURATION */.$m,
                            elevation: 1,
                            slotIdentifier: componentOptions.component_home_mobile_middle_id || componentOptions.component_game_ads_id || "idhb-bottom-90",
                            variant: "320x100"
                        })
                    })
                ]
            })
        ]
    });
}
// Adding getLayout property. Allowing us to return a React component for the layout.
// This allows us to define the layout on a per-page basis. Since we're returning a function,
// we can have complex nested layouts if desired.
IndexPage.getLayout = function getLayout(page) {
    var props = page.props;
    var pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseLayout/* BaseLayout */.I, {
        pageType: "index",
        pageContext: pageContext,
        children: page
    });
};


/***/ }),

/***/ 86731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useFlattenedGameData = function(initialData) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), flattenedData = ref[0], setFlattenedData = ref[1];
    // Veriyi düzleştiren fonksiyon
    var flattenData = function(data) {
        var flattenedArray = data.reduce(function(acc, curr) {
            if (Array.isArray(curr)) {
                var _acc;
                (_acc = acc).push.apply(_acc, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(curr));
            } else {
                acc.push(curr);
            }
            return acc;
        }, []);
        return flattenedArray;
    };
    // Başlangıçta veriyi düzleştir
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (initialData && initialData.length) {
            setFlattenedData(flattenData(initialData));
        }
    }, [
        initialData
    ]);
    return flattenedData;
};
/* harmony default export */ __webpack_exports__["Z"] = (useFlattenedGameData);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2906,3818,978,2214,473,1074,3044,5152,3500,4821,7637,3639,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);